/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Level</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Points</label>
                        <input type="number" ref="points" id="" class="form-control mb-4" placeholder="Points">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Title</label>
                        <input type="text" ref="title" id="" class="form-control mb-4" placeholder="Title">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Step</label>
                        <input type="number" id="" ref="step" class="form-control mb-4" placeholder="Step">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Target</label>
                        <select class="form-control mb-4" ref="target">
                            <option value="RUNNER">RUNNER</option>
                            <option value="TODDLER">TODDLER</option>
                        </select>
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addLevel()">Add Level</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddLevel',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addLevel() {
            let data = {
                points: parseInt(this.$refs.points.value),
                title: this.$refs.title.value,
                step: parseInt(this.$refs.step.value),
                target: this.$refs.target.value
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Creating Level Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/level/create", data, config)

                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Level Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    }
}
</script>
